import { SymbolsAnimationFactory } from './SymbolsAnimationFactory'
import { SymbolContainerData } from '@/modules'

export class CommonSymbolsFactory extends SymbolsAnimationFactory {
    private readonly _resource: string
    private readonly _animations: Record<string, string>

    public constructor(resource: string, animations: Record<string, string> = { win: 'animation' }) {
        super()

        this._resource = resource
        this._animations = animations
    }

    public getAnimationResource(): string {
        return this._resource
    }

    public getAnimationLabel(symbolData: SymbolContainerData, state: string): string {
        return this._animations[state] ?? this._animations.default
    }
}
